export function degreesToRadians(degrees: number) {
  return degrees * (Math.PI / 180);
}

/*
 * Calculates the haversine distance between two points on the Earth's surface.
 * @param point1 - The coordinates of the first point.
 * @param point2 - The coordinates of the second point.
 * @param radius - The radius of the sphere (defaults to average radius of Earth: 6,371,000 meters).
 * @returns The haversine distance between the two points in meters.
 *
 * adapted from https://github.com/dcousens/haversine-distance/blob/main/index.js
 */
export function haversineDistance(
  point1: { latitude: number; longitude: number },
  point2: { latitude: number; longitude: number },
  radius: number = 6_371_000
) {
  const squared = (x: number) => x ** 2;
  const { sin, sqrt, cos, asin } = Math;

  const aLat = degreesToRadians(point1.latitude);
  const bLat = degreesToRadians(point2.latitude);
  const aLng = degreesToRadians(point1.longitude);
  const bLng = degreesToRadians(point2.longitude);

  const ht =
    squared(sin((bLat - aLat) / 2)) +
    cos(aLat) * cos(bLat) * squared(sin((bLng - aLng) / 2));
  return 2 * radius * asin(sqrt(ht));
}
